module.exports = __webpack_public_path__ + "img/06.c0db8c70.jpg";